(function() {
    var styleTag = document.createElement('style');
    document.head.appendChild(styleTag);

    // Estados globais
    window.pagamentoShow = false;   // começa fechado
    window.parcelasShow = true;     // começa aberto

    function ensureDisplayNone(seletor) {
        var cssRules = styleTag.sheet.cssRules;
        for (var i = 0; i < cssRules.length; i++) {
            if (cssRules[i].selectorText === seletor) return;
        }
        styleTag.sheet.insertRule(seletor + ' { display: none !important; }', cssRules.length);
    }

    function toggleContent(seletor, estadoVar) {
        var content = document.querySelector(seletor);
        if (!content) return;

        var cssRules = styleTag.sheet.cssRules;
        var regraIndex = null;

        // Garante estado inicial via CSS apenas se necessário
        if (!window[estadoVar]) {
            ensureDisplayNone(seletor);
        }

        // Verifica se já existe regra display:block
        for (var i = 0; i < cssRules.length; i++) {
            if (cssRules[i].selectorText === seletor && cssRules[i].style.display === 'block') {
                regraIndex = i;
                break;
            }
        }

        // Toggle baseado na variável global
        if (window[estadoVar]) {
            // Se true → fechar
            window[estadoVar] = false;

            content.style.overflow = 'hidden';
            content.style.maxHeight = content.scrollHeight + 'px';
            content.offsetHeight; // força reflow
            content.style.maxHeight = '0';

            setTimeout(() => {
                if (regraIndex !== null && regraIndex < styleTag.sheet.cssRules.length) {
                    styleTag.sheet.deleteRule(regraIndex);
                }
                content.style.overflow = '';
                // Aplica display: none após a animação
                ensureDisplayNone(seletor);
            }, 500);
        } else {
            // Se false → abrir
            window[estadoVar] = true;

            if (regraIndex === null) {
                styleTag.sheet.insertRule(seletor + ' { display: block !important; }', cssRules.length);
            }

            content.style.overflow = 'hidden';
            content.style.maxHeight = '0';
            content.offsetHeight; // força reflow
            content.style.maxHeight = content.scrollHeight + 'px';

            setTimeout(() => {
                content.style.overflow = '';
                content.style.maxHeight = '';
            }, 500);
        }
    }

    // Funções globais
    window.mostrarPagamentos = function() { toggleContent('.essence-payments', 'pagamentoShow'); };
    window.mostrarParcelas   = function() { toggleContent('.payment-content', 'parcelasShow'); };
})();